import {useAuth} from '@/hooks/auth-provider'
import {useEffect, useState} from 'react'

const cache: {[key: string]: string} = {}

export function PrivateImg({src, ...props}: React.ImgHTMLAttributes<HTMLImageElement>) {
  const auth = useAuth()
  const [srcProps, setSrcProps] = useState<{src: string} | {}>({})

  const cached = src && cache[src]

  useEffect(() => {
    if (cached) {
      setSrcProps({src: cached})
      return
    }
    fetch(src!, {headers: auth.header})
      .then(res => res.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob)
        cache[src!] = url
        setSrcProps({src: url})
      })
  }, [src, auth.header, cached])

  return <img {...srcProps} {...props} />
}
